<template>
    <header>
        <div class="header-content">
            <h1 class="header-content-title">Byte Hive</h1>
            <h2 class="header-content-subtitle">{{ props.subTitle }}</h2>
        </div>
    </header>
</template>

<script setup>
const props = defineProps({
    subTitle: String,
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
